import React from 'react';
import { useLocale } from '../i18n';
import type { Locale } from '../i18n/translations';

const LANGUAGES: { code: Locale; flag: string; label: string }[] = [
  { code: 'en', flag: '🇺🇸', label: 'English' },
  { code: 'zh', flag: '🇨🇳', label: '中文' },
  { code: 'ja', flag: '🇯🇵', label: '日本語' },
  { code: 'ko', flag: '🇰🇷', label: '한국어' },
];

const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale } = useLocale();

  return (
    <select
      value={locale}
      onChange={(e) => setLocale(e.target.value as Locale)}
      style={{
        fontSize: '12px',
        padding: '3px 6px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        background: 'transparent',
        color: '#555',
        cursor: 'pointer',
      }}
    >
      {LANGUAGES.map(({ code, flag, label }) => (
        <option key={code} value={code}>{flag} {label}</option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;
